// extracted by mini-css-extract-plugin
module.exports = {"title":"w_S","list":"w_bn","listSquare":"w_bp","eyebrow":"w_H","subTitle":"w_bt","platforms":"w_bv"};